var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c(
      "div",
      { staticClass: "bulk-tag-uploader" },
      [
        _c("span", [
          _c(
            "button",
            {
              staticClass: "btn btn-default btn-sm input-group-btn__icon",
              attrs: { disabled: !_vm.bulkTagFileId },
              on: { click: _vm.showBulkTagSearch }
            },
            [_c("i", { staticClass: "fa fa-search p-r-0" })]
          )
        ]),
        _vm._v(" "),
        _c("SearchableDropdown", {
          staticClass: "m-0 bulk-tag-uploader__select",
          attrs: { config: _vm.dropdownConfig },
          on: { change: _vm.onExistingFileSelect },
          scopedSlots: _vm._u([
            {
              key: "option-data",
              fn: function({ option }) {
                return [
                  _vm._v("\n        " + _vm._s(option.name) + "\n        "),
                  _c("i", { staticClass: "m-l-5 f-s-11 m-t-2 text-muted" }, [
                    _vm._v(_vm._s(option.tagCount) + " tags")
                  ])
                ]
              }
            },
            {
              key: "selected-option-data",
              fn: function({ option }) {
                return [
                  _c(
                    "span",
                    {
                      staticStyle: {
                        overflow: "hidden",
                        "text-overflow": "ellipsis"
                      },
                      attrs: {
                        title: `${option.name} - ${option.tagCount} tags`
                      }
                    },
                    [
                      _vm._v(
                        "\n          " + _vm._s(option.name) + "\n          "
                      ),
                      _c(
                        "i",
                        { staticClass: "m-l-5 f-s-11 m-t-2 text-muted" },
                        [_vm._v(_vm._s(option.tagCount) + " tags")]
                      )
                    ]
                  )
                ]
              }
            }
          ]),
          model: {
            value: _vm.bulkTagFileId,
            callback: function($$v) {
              _vm.bulkTagFileId = $$v
            },
            expression: "bulkTagFileId"
          }
        }),
        _vm._v(" "),
        _c(
          "span",
          [
            _c(
              "file-upload",
              {
                ref: "uploadButton",
                staticClass:
                  "btn btn-default btn-sm input-group-btn__icon clickable file-uploads--custom",
                attrs: {
                  extensions: "txt",
                  accept: "text/plain",
                  name: "bulkTagFileUpload",
                  disabled: _vm.showFileLoader
                },
                on: { "input-file": _vm.onNewFileUpload },
                model: {
                  value: _vm.bulkTagFile,
                  callback: function($$v) {
                    _vm.bulkTagFile = $$v
                  },
                  expression: "bulkTagFile"
                }
              },
              [
                !_vm.showFileLoader
                  ? _c("i", { staticClass: "fa fa-cloud-upload fa-lg p-r-0" })
                  : _vm._e(),
                _vm._v(" "),
                _vm.showFileLoader
                  ? _c("Loader", {
                      attrs: {
                        "custom-class":
                          "loader-container m-t-4 size-sm loader-container--no-margin"
                      }
                    })
                  : _vm._e()
              ],
              1
            )
          ],
          1
        )
      ],
      1
    ),
    _vm._v(" "),
    _vm.showSearchInput
      ? _c(
          "div",
          { staticClass: "phone-validation-icon-container" },
          [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model.trim",
                  value: _vm.searchTag,
                  expression: "searchTag",
                  modifiers: { trim: true }
                }
              ],
              staticClass: "form-control",
              attrs: {
                type: "search",
                placeholder: "Search tag in selected bulk upload"
              },
              domProps: { value: _vm.searchTag },
              on: {
                input: [
                  function($event) {
                    if ($event.target.composing) return
                    _vm.searchTag = $event.target.value.trim()
                  },
                  _vm.searchTagInput
                ],
                blur: function($event) {
                  return _vm.$forceUpdate()
                }
              }
            }),
            _vm._v(" "),
            _vm.showLoader
              ? _c("Loader", {
                  attrs: { "custom-class": "loader-container size-sm" }
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.searchTagExists === false
              ? _c("i", {
                  staticClass: "fa fa-times text-danger phone-validation-icon"
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.searchTagExists
              ? _c("i", {
                  staticClass: "fa fa-check text-success phone-validation-icon"
                })
              : _vm._e()
          ],
          1
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }